// Establishes `window.jQuery` / `window.$` before any sibling import in main.js
// evaluates. Must be the first import in main.js.
//
// The layouts load main.min.js before flex.min.js (see README "Script load order
// matters"), so on pages with a flex-form, flex.min.js later replaces window.jQuery
// with its own instance (with jquery-placeholder / jquery-validation registered).
// The nullish guard only keeps a jQuery that is already on window (e.g. from a
// page-level script) instead of overwriting it.
import $ from 'jquery';

window.jQuery ??= $;
window.$ ??= $;
